import constant from "./constant";
import { formatUserFacingError, MSG } from "./constants/userMessages.js";

export const removeStorage = (keyName) => {
  localStorage.removeItem(keyName);
}

export const setStorage = (key, jsonObj) => {
  localStorage.setItem(key, JSON.stringify(jsonObj))
}


export const getStorage = (keyName) => {
  const item = localStorage.getItem(keyName);
  return JSON.parse(item);
}

export const removeAllLocalStorage = () => {
  localStorage.clear();
}

export const removeSessionStorage = (keyName) => {
  sessionStorage.removeItem(keyName);
}

export const setSessionStorage = (key, jsonObj) => {
  sessionStorage.setItem(key, JSON.stringify(jsonObj));
}

export const getSessionStorage = (keyName) => {
  const item = sessionStorage.getItem(keyName);
  return JSON.parse(item);
}

export const removeAllSessionStorage = () => {
  sessionStorage.clear();
}

export const validateFunctionalForm = (state, setState) => {
  let status = true;

  const validateField = (field) => {
    if (!field?.isRequired) return { ...field, error: "" };

    const value = field.value;

    if (value === undefined || value === null) {
      status = false;
      return { ...field, error: "This field is required" };
    }

    if (typeof value === "string" && value.trim() === "") {
      status = false;
      return { ...field, error: "This field is required" };
    }

    if (Array.isArray(value) && value.length === 0) {
      status = false;
      return { ...field, error: "This field is required" };
    }

    return { ...field, error: "" };
  };

  const validateObject = (obj) => {
    const updated = { ...obj };

    Object.keys(updated).forEach((key) => {
      const field = updated[key];

      // 🔥 nested array (units)
      if (Array.isArray(field)) {
        updated[key] = field.map((item) => validateObject(item));
      }

      // 🔥 normal field
      else if (field && typeof field === "object" && "value" in field) {
        updated[key] = validateField(field);
      }

      // 🔥 nested object
      else if (typeof field === "object") {
        updated[key] = validateObject(field);
      }
    });

    return updated;
  };

  let updatedState;

  // ✅ Case 1: Array
  if (Array.isArray(state)) {
    updatedState = state.map((item) => validateObject(item));
  }
  // ✅ Case 2: Object
  else {
    updatedState = validateObject(state);
  }

  setState(updatedState);
  return status;
};



export const getAuthHeader = () => {
  const config = { withCredentials: true, headers: {} };
  try {
    const token = getStorage(constant.keys.userToken);
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
  } catch {
    // HttpOnly cookie carries the session token
  }
  return config;
};

/** fetch() init — axios `withCredentials` is ignored; use credentials: "include". */
export const getFetchAuthInit = (init = {}) => {
  const auth = getAuthHeader();
  return {
    ...init,
    credentials: "include",
    headers: { ...(auth.headers || {}), ...(init.headers || {}) },
  };
};

export const getUserFacingError = (err, fallback = MSG.requestFailed) =>
  formatUserFacingError(
    err?.response?.data?.error?.message ||
      err?.response?.data?.error ||
      err?.message,
    fallback
  );

export const userFacingError = getUserFacingError;

export const parseApiErrorMessage = (body, fallback = MSG.requestFailed) => {
  if (!body) return formatUserFacingError(fallback, fallback);
  let message = fallback;
  if (typeof body.error === "string") message = body.error;
  else if (body.error?.message) message = body.error.message;
  else if (body.message) message = body.message;
  return formatUserFacingError(message, fallback);
};

/** Prevent axios rejections from surfacing as uncaught runtime errors on read calls. */
export const catchApi = (promise) =>
  promise.catch((error) => ({
    status: false,
    allowed: false,
    error: {
      message: parseApiErrorMessage(
        error?.response?.data,
        error?.message || MSG.requestFailed
      ),
    },
  }));

/** Parse JSON error body returned as blob from axios responseType: "blob". */
export const parseAxiosBlobError = async (error, fallback = MSG.requestFailed) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text());
      return parseApiErrorMessage(json, fallback);
    } catch {
      return fallback;
    }
  }
  return parseApiErrorMessage(error?.response?.data, fallback);
};

export const setAuthSession = () => {
  sessionStorage.setItem(constant.keys.authSession, "1");
  removeStorage(constant.keys.userToken);
}

export const clearAuthSession = () => {
  sessionStorage.removeItem(constant.keys.authSession);
  removeStorage(constant.keys.userToken);
}

export const hasAuthSession = () => {
  if (sessionStorage.getItem(constant.keys.authSession) === "1") return true;
  try {
    return !!localStorage.getItem(constant.keys.userToken);
  } catch {
    return false;
  }
}



export const formatVoyageNumber = (voyage) => {
  if (!voyage) return "";

  return voyage.voyage_number;
};



/* ================= HELPERS ================= */
export const formatDateTime = (val) => {
  if (!val) return "-";
  const d = new Date(val);
  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const yesNo = (val) => (val ? "Yes" : "No");